export default __webpack_public_path__ + "static/AppMoneyWalkie11-e38b7563e0a31bdeebb743a02865b0c9.png";